import './Nav.scss';
import React, { FC } from 'react';
import Loading from '@/components/basic/Loading/Loading';
import NavItem from './NavItem';
import NavArea from './NavArea';
import { useFoyerConfig, useFoyerConfigDispatch } from '../FoyerProvider';
import { concatenateIdToPath } from '@/utils';
import ButtonIcon from '@/components/basic/ButtonIcon/ButtonIcon';

type NavProps = Record<string, never>;

const Nav: FC<NavProps> = () => {
    const foyerConfig = useFoyerConfig();
    const foyerConfigDispatch = useFoyerConfigDispatch();
    if (!foyerConfig.initialized) return <Loading type="element" />;

    const currentNavGroupTitle = foyerConfig.activeZoneItem
        ? foyerConfig.activeZoneItem.title
        : foyerConfig.activeRealmItem
          ? foyerConfig.activeRealmItem.title
          : false;

    const goPrevNavAreas = () => {
        if (currentNavGroupTitle) {
            foyerConfigDispatch({
                type: 'GO_PREV_NAV_AREAS',
            });
        }
    };

    return (
        <>
            <header className="Nav_header">
                <ButtonIcon
                    icon="back"
                    label="zurück"
                    disabled={!currentNavGroupTitle}
                    onClick={goPrevNavAreas}
                />
                {currentNavGroupTitle && (
                    <h2 className="Nav_areaTitle">{currentNavGroupTitle}</h2>
                )}
            </header>
            <section className="Nav_area realm">
                {foyerConfig.realms.length &&
                    foyerConfig.realms.map((realm) => {
                        return (
                            <NavItem
                                key={realm.id}
                                navAreaName="realm"
                                item={realm}
                                path={concatenateIdToPath({
                                    id: realm.id,
                                    pathId: realm.pathId,
                                })}
                                className={realm.config}
                            />
                        );
                    })}
            </section>
            {foyerConfig.zoneGroups.map((zoneGroup) => (
                <NavArea
                    key={zoneGroup.parentId}
                    navAreaName="zone"
                    navArea={zoneGroup}
                />
            ))}

            {foyerConfig.matrixGroups.map((matrixGroup) => (
                <NavArea
                    key={matrixGroup.parentId}
                    navAreaName="matrix"
                    navArea={matrixGroup}
                />
            ))}
        </>
    );
};

export default Nav;
